<template>
  <div class="column justify-center items-center q-mt-sm q-mb-lg text-grey-7">
    <q-icon name="search_off" size="xl" />
    <div class="text-h6">No units found</div>
    <div class="text-body2">Please adjust your filters to see results</div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'NoUnitsFound'
}
</script>

<style scoped></style>
